import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../../AuthContext'
import { Title, Subtitle } from '../../Utils/CustomClasses'
import MyFreebirdConditionalLink from '../MyFreebirdConditionalLink'
import styled from 'styled-components'

const CommunityPostsContainer = styled.div`
  border-bottom: 1px solid #ede8e9;
  margin: 10px 0 20px;

  &:last-of-type {
    border-bottom: 0;
  }

  h1 {
    font-size: 16px;
    font-weight: 300;
  }

  h2 {
    text-transform: uppercase;
  }
`

const CustomBold = styled.b`
  color: ${(props) => (props.color ? props.color : '#000')};
`

const MemberPosts = ({ stage1Achieved }) => {
  const [results, setResults] = useState('')

  useEffect(() => {
    axios
      .get(`/api/VYGVA82re2f8e2/memberposts?perpage=2&pageno=1`)
      .then((response) => {
        setResults(
          response.data.map((d, index) => {
            return (
              <CommunityPosts
                key={index}
                title={
                  d[5].body.body
                    .replace(/(<([^>]+)>)/gi, '')
                    .split(/\s+/)
                    .slice(0, 40)
                    .join(' ') + '...'
                }
                category={d[0]}
                color={d[1]}
                circleId={d[2]}
                freebirdId={d[3]}
                circleSlug={d[4]}
                name={d[5].user_name}
                country={d[6]}
              />
            )
          })
        )
      })
      .catch((err) => {
        console.log('Error getting member posts: ', err)
      })
  }, [stage1Achieved])

  const CommunityPosts = ({
    title,
    category,
    color,
    circleId,
    freebirdId,
    circleSlug,
    name,
    country,
  }) => {
    return (
      <CommunityPostsContainer>
        <MyFreebirdConditionalLink
          linkUrl={'/dashboard/community2?lp=' + circleSlug}
          stage1Achieved={stage1Achieved}
        >
          <Title size="20px" sizemd="20px" sizesm="20x" margin="0 0 20px 0">
            {title}
          </Title>
        </MyFreebirdConditionalLink>
        <Subtitle
          color="#ADADAD"
          size="16px"
          sizemd="16px"
          sizesm="16x"
          margin="0"
        >
          Member:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <MyFreebirdConditionalLink
            linkUrl={
              circleId
                ? '/dashboard/community2?lp=user-' + circleId
                : freebirdId
                  ? '/user/' + freebirdId
                  : null
            }
            stage1Achieved={stage1Achieved}
          >
            <CustomBold color={'#585858'}> {name} </CustomBold>
          </MyFreebirdConditionalLink>
        </Subtitle>
        <Subtitle
          color="#ADADAD"
          size="16px"
          sizemd="16px"
          sizesm="16x"
          margin="0"
        >
          Country:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <CustomBold color={'#585858'}> {country} </CustomBold>
        </Subtitle>
        <Subtitle
          color="#ADADAD"
          size="16px"
          sizemd="16px"
          sizesm="16x"
          margin="0 0 15px 0"
        >
          Category:&nbsp;&nbsp;&nbsp;&nbsp;
          <MyFreebirdConditionalLink
            linkUrl={'/dashboard/community2?lp=' + circleSlug}
            stage1Achieved={stage1Achieved}
          >
            <CustomBold color={color}> {category} </CustomBold>
          </MyFreebirdConditionalLink>
        </Subtitle>
      </CommunityPostsContainer>
    )
  }

  if (!results) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ margin: '100px auto 100px', opacity: '0.3' }}
          role="status"
        ></div>
      </div>
    )
  }
  return results
}

export default withRouter(withAuth(MemberPosts))
